import React from 'react';
import { motion } from 'framer-motion';
import { recipeStudioFeatures, recipeStudioImage } from '../data/content';
import { Heading } from './Primitives';
export function RecipeStudio() {
  return <section aria-label="Pawsy Recipe Studio" className="bg-white px-5 py-9 sm:px-8 sm:py-10" data-id="element-187" data-mp="2poazh4audh00">
      <motion.div initial={{
      opacity: 0,
      y: 14
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="mx-auto w-full max-w-4xl rounded-2xl border border-dashed border-ink-400/40 bg-cream px-5 py-6 sm:px-7" data-id="element-188" data-mp="2kq9lgxs9w7ve">
        <div className="flex flex-col items-center gap-4 text-center sm:flex-row sm:items-center sm:gap-5 sm:text-left" data-id="element-189" data-mp="26qgwp80b41q2">
          <img src={recipeStudioImage} alt="Pawsy Recipe Studio on a phone screen, surrounded by fresh ingredients" loading="lazy" decoding="async" className="h-20 w-20 shrink-0 rounded-xl border border-orangey-100 object-cover" data-id="element-190" data-mp="21symzfegtih0" />
          <div data-id="element-191" data-mp="2tup4yjiogkes">
            <p className="font-mono text-[0.65rem] font-semibold uppercase tracking-[0.16em] text-ink-400" data-id="element-192" data-mp="2yrpc6xr9jt7h">
              🍲 Optional add-on · separate from the $29 plan
            </p>
            <Heading size="md" className="mt-1.5 !text-2xl sm:!text-[1.75rem]" data-id="element-193" data-mp="2jwsultxkdthq">
              Want to cook homemade meals too?
            </Heading>
            <p className="mt-2 leading-relaxed text-ink-500" data-id="element-194" data-mp="3ck569926sgw9">
              Pawsy Companion tells you how much to feed. Recipe Studio shows you exactly what to cook.
            </p>
          </div>
        </div>

        <ul className="mt-5 flex flex-wrap justify-center gap-2 sm:justify-start" data-id="element-195" data-mp="32sixdjdbmtwo">
          {recipeStudioFeatures.map(feature => <li key={feature.label} className="flex items-center gap-1.5 rounded-xl border border-orangey-100 bg-white px-3 py-1.5 text-sm font-semibold text-ink-700" data-id="element-196" data-mp="37q0y4mh6q2tl">
              <span aria-hidden="true" data-id="element-197" data-mp="dzaj72a7dgzz">{feature.emoji}</span>
              {feature.label}
            </li>)}
        </ul>

        <p className="mt-4 text-center font-mono text-[0.65rem] font-semibold uppercase tracking-[0.14em] text-ink-400 sm:text-left" data-id="element-198" data-mp="8zxzgqemoq1m">
          Available as a one-click add-on during checkout.
        </p>
      </motion.div>
    </section>;
}